const bodyScrollLock = require(`body-scroll-lock`);
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

import VideoPreviewView from "./../view/video-preview.js";
import OverlayView from "./../view/overlay.js";
import Animation from "./../../animation/animation.js";

import {
  render,
  remove
} from "./../../render/render.js";

import {TRANSITION_DURATION} from "./../const.js";

export default class VideoPopup {
  constructor(element, model) {
    this._element = element;
    this._body = document.body;
    this._model = model;
    this._animation = new Animation();
    this._transitionDuration = TRANSITION_DURATION;

    this._previewView = null;
    this._overlayView = null;

    this._handlePreviewClick = this._handlePreviewClick.bind(this);
    this._handleEscKeyDown = this._handleEscKeyDown.bind(this);
    this._handleOverlayClick = this._handleOverlayClick.bind(this);
    this._handleChangeModel = this._handleChangeModel.bind(this);

    this._model.addObserver(this._handleChangeModel);
  }

  init() {
    this._previewView = new VideoPreviewView(this._element);
    this._previewView.setPreviewClickHandler(this._handlePreviewClick);
    this._previewView.setPreviewKeyDownHandler(this._handlePreviewClick);
  }

  _handlePreviewClick() {
    if (!this._overlayView) {
      this._overlayView = new OverlayView(this._previewView.getVideoSrc());
    }

    if (!this._overlayView.getVideo()) {
      const videoSectionElement = this._overlayView.getElement();

      this._overlayView.setVideo();
      render(this._body, videoSectionElement);
      disableBodyScroll(this._overlayView.getElement());

      this._animation.fadeIn(
          videoSectionElement,
          this._transitionDuration,
          () => {
            this._overlayView.setOverlayClickHandler(this._handleOverlayClick);
            this._showVideo();
          }
      );

      document.addEventListener(`keydown`, this._handleEscKeyDown);
    }
  }

  _showVideo() {
    this._overlayView.showVideo();
    this._overlayView.getVideo().focus();
    this._overlayView.getVideo().muted = true;
    this._overlayView.getVideo().play();
    this._model.changeStatus();
  }

  _handleEscKeyDown(evt) {
    if (evt.key === `Escape` || evt.key === `Esc`) {
      evt.preventDefault();
      this._closeOverlay();
    }
  }

  _handleOverlayClick(evt) {
    evt.preventDefault();
    this._closeOverlay();
  }

  _closeOverlay() {
    this._overlayView.getVideo().pause();
    this._animation.fadeOut(
        this._overlayView.getElement(),
        this._transitionDuration,
        () => {
          enableBodyScroll(this._overlayView.getElement());
          remove(this._overlayView);
          this._overlayView.removeVideo();
        }
    );
    this._model.changeStatus();

    document.removeEventListener(`keydown`, this._handleEscKeyDown);
  }

  _handleChangeModel() {
    this._model.setVideo(
        Object.assign(
            {},
            this._model.getVideo(),
            {
              isOpen: !this._model.getVideo().isOpen
            }
        )
    );
  }
}
